import type { DeleteApiAdminsIdPathParams } from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'

import { adminCreate, adminDelete, adminUpdate } from '../api'

sample({
  clock: adminCreate.finished.success,
  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

sample({
  clock: adminUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})

export const adminDeleted = createEvent<{
  id: DeleteApiAdminsIdPathParams['Id']
}>()

sample({
  clock: adminDeleted,
  fn: ({ id }) => ({ id }),
  target: [adminDelete.start],
})

sample({
  clock: adminDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})
